import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonContent } from '@ionic/angular/standalone';
import { BevmeHeaderComponent } from '../shared/bevme-header/bevme-header.component';

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [IonContent, CommonModule, BevmeHeaderComponent],
  templateUrl: './faq.page.html',
  styleUrls: ['./faq.page.scss'],
})
export class FaqPage {}
